(() => {
  'use strict';
  const strings = JSON.parse(document.getElementById('CommerceStrings').textContent);
  const route = (path) => `${window.Shopify?.routes?.root || '/'}${path}`;
  const all = (selector, root = document) => [...root.querySelectorAll(selector)];
  let cartBusy = false;
  let cartOpener = null;

  const setMessage = (element, message) => {
    if (element) element.textContent = message;
  };
  const syncDiscount = (element, priceCents, compareCents) => {
    if (!element) return;
    const price = Number(priceCents);
    const compare = Number(compareCents);
    const percent = Number.isFinite(price) && Number.isFinite(compare) && compare > price && compare > 0
      ? 20 : 0;
    element.hidden = percent <= 0;
    setMessage(element, percent > 0 ? element.dataset.discountFormat.replace('{percent}', String(percent)) : '');
  };
  const cartMessage = (message) => all('[data-cart-status]').forEach((node) => setMessage(node, message));
  const formVariant = (form) => {
    const root = form.closest('[data-product-root]');
    const id = form.elements.namedItem('id')?.value;
    const variant = root?.rcProduct?.variants.find((entry) => String(entry.id) === id);
    if (variant) return variant;
    const option = form.querySelector('[data-complement-variant]')?.selectedOptions[0];
    return option ? { available: option.dataset.available === 'true' } : null;
  };
  const syncFormButtons = (form) => {
    const variant = formVariant(form);
    const busy = form.getAttribute('aria-busy') === 'true';
    all('[data-add-button]').filter((button) => button.form === form).forEach((button) => {
      button.disabled = busy || cartBusy || variant?.available === false;
      button.toggleAttribute('aria-busy', busy);
      if (busy) button.setAttribute('aria-busy', 'true');
      setMessage(button.querySelector('[data-add-label]'), busy ? strings.adding : variant?.available === false ? strings.sold_out : strings.add_to_cart);
    });
  };
  const syncSticky = (root) => {
    const variant = formVariant(root.querySelector('[data-add-form]'));
    if (!variant) return;
    setMessage(root.querySelector('[data-sticky-shade]'), root.rcProduct.defaultVariant ? root.rcProduct.title : variant.title);
    setMessage(root.querySelector('[data-sticky-price]'), variant.price);
    const compare = root.querySelector('[data-sticky-compare]');
    if (compare) { compare.hidden = !variant.compare; setMessage(compare, variant.compare || ''); }
    syncDiscount(root.querySelector('[data-sticky-discount]'), variant.priceCents, variant.compareAtPriceCents);
    setMessage(root.querySelector('[data-sticky-quantity]'), ` × ${root.querySelector('[name="quantity"]').value}`);
    const stock = root.querySelector('[data-product-stock]');
    if (stock) { stock.hidden = !variant.stock; setMessage(stock, variant.stock || ''); }
  };
  const selectComplement = (select) => {
    const option = select.selectedOptions[0];
    const row = select.closest('[data-complementary-product]');
    if (!option || !row) return;
    const form = select.form;
    form.elements.namedItem('quantity').value = option.dataset.minimum || '1';
    setMessage(row.querySelector('[data-complement-price]'), option.dataset.price);
    const compare = row.querySelector('[data-complement-compare]');
    const onSale = Number(option.dataset.compareCents) > Number(option.dataset.priceCents);
    if (compare) { compare.hidden = !onSale; setMessage(compare, onSale ? option.dataset.compare || '' : ''); }
    syncDiscount(row.querySelector('[data-complement-discount]'), option.dataset.priceCents, option.dataset.compareCents);
    all('[data-complement-link]', row).forEach((link) => { link.href = option.dataset.url; });
    const image = row.querySelector('[data-complement-image]');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    setMessage(form.querySelector('[data-form-message]'), '');
    syncFormButtons(form);
  };
  const openCart = (opener) => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer?.showModal) return false;
    if (!drawer.open) {
      cartOpener = opener?.isConnected ? opener : document.querySelector('[data-cart-open]') || document.activeElement;
      drawer.showModal();
    }
    return true;
  };
  const closeCart = () => {
    document.getElementById('CartDrawer')?.close();
    if (cartOpener?.isConnected) cartOpener.focus();
  };
  const sectionIds = () => ['cart-drawer', ...all('[data-cart-section]').map((node) => node.dataset.cartSection)];
  const replaceCart = (sections) => {
    if (!sections?.['cart-drawer']) return false;
    const parser = new DOMParser();
    const drawerDocument = parser.parseFromString(sections['cart-drawer'], 'text/html');
    const freshDrawer = drawerDocument.querySelector('[data-cart-drawer-content]');
    const currentDrawer = document.querySelector('[data-cart-drawer-content]');
    if (!freshDrawer || !currentDrawer) return false;
    const focused = document.activeElement?.dataset?.cartFocus;
    const focusWithin = document.activeElement?.closest('#CartDrawer') ? '#CartDrawer' : '[data-cart-page]';
    currentDrawer.replaceWith(freshDrawer);
    all('[data-cart-page]').forEach((page) => {
      const html = sections[page.dataset.cartSection];
      if (!html) return;
      const fresh = parser.parseFromString(html, 'text/html').querySelector('[data-cart-page-content]');
      if (fresh) page.querySelector('[data-cart-page-content]')?.replaceWith(fresh);
    });
    all('[data-cart-count]').forEach((node) => {
      node.textContent = freshDrawer.dataset.cartCountValue || '0';
    });
    all('[data-complement-variant]').forEach(selectComplement);
    if (focused) {
      const scope = document.querySelector(focusWithin);
      const target = scope && all('[data-cart-focus]', scope).find((node) => node.dataset.cartFocus === focused);
      if (target) target.focus({ preventScroll: true });
      else if (scope?.id === 'CartDrawer') scope.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('rc:cart-updated', { detail: { count: Number(freshDrawer.dataset.cartCountValue) } }));
    return true;
  };
  const refreshCart = async () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) return false;
    return replaceCart(await response.json());
  };
  const post = async (path, body) => {
    const options = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body };
    if (!(body instanceof FormData)) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    const response = await fetch(route(path), options);
    let result;
    try { result = await response.json(); } catch { throw new Error(strings.connection_error); }
    if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : strings.cart_error_retry);
    return result;
  };
  const syncCart = async (sections) => {
    try {
      if (replaceCart(sections) || await refreshCart()) return true;
    } catch { /* The mutation has succeeded; never retry it when only rendering failed. */ }
    window.location.assign(route('cart'));
    return false;
  };
  const changeLine = async (line, quantity) => {
    if (cartBusy) return;
    const input = line.querySelector('[data-cart-quantity]');
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const original = input.defaultValue;
    cartBusy = true;
    all('[data-add-form]').forEach(syncFormButtons);
    cartMessage('');
    all('[data-cart-line]').forEach((node) => node.setAttribute('aria-busy', 'true'));
    try {
      const result = await post('cart/change.js', { id: line.dataset.lineKey, quantity, sections: sectionIds(), sections_url: window.location.pathname });
      await syncCart(result.sections);
      cartMessage(quantity ? strings.cart_updated : strings.item_removed);
    } catch (error) {
      input.value = original;
      cartMessage(error.message || strings.cart_error);
    } finally {
      cartBusy = false;
      all('[data-add-form]').forEach(syncFormButtons);
      all('[data-cart-line]').forEach((node) => node.removeAttribute('aria-busy'));
    }
  };
  const quantityStep = (button) => {
    const input = button.closest('.quantity-control')?.querySelector('input');
    if (!input || cartBusy) return;
    const step = Number(input.step) || 1;
    const min = Number(input.min) || 0;
    const max = input.max ? Number(input.max) : Infinity;
    const quantity = Math.max(min, Math.min(max, (Number(input.value) || min) + Number(button.dataset.quantityStep) * step));
    const line = button.closest('[data-cart-line]');
    if (line) changeLine(line, quantity);
    else { input.value = String(quantity); const root = input.closest('[data-product-root]'); if (root) syncSticky(root); }
  };
  const selectVariant = (root, variantId, updateUrl = true) => {
    const variant = root.rcProduct?.variants.find((entry) => String(entry.id) === String(variantId));
    if (!variant) return;
    root.querySelector('[data-variant-select]').value = String(variant.id);
    setMessage(root.querySelector('[data-product-price]'), variant.price);
    const sku = root.querySelector('[data-product-sku]');
    if (sku && typeof variant.sku === 'string') { sku.textContent = variant.sku; sku.parentElement.hidden = !variant.sku; }
    const compare = root.querySelector('[data-product-compare]');
    compare.hidden = !variant.compare;
    setMessage(compare, variant.compare || '');
    syncDiscount(root.querySelector('[data-product-discount]'), variant.priceCents, variant.compareAtPriceCents);
    setMessage(root.querySelector('[data-selected-shade]'), variant.title);
    setMessage(root.querySelector('[data-shade-note]'), variant.note || '');
    syncFormButtons(root.querySelector('[data-add-form]'));
    setMessage(root.querySelector('[data-form-message]'), '');
    const quantity = root.querySelector('input[name="quantity"]');
    quantity.min = String(variant.min);
    quantity.step = String(variant.increment);
    if (variant.max) quantity.max = String(variant.max);
    else quantity.removeAttribute('max');
    quantity.value = String(variant.min);
    syncSticky(root);
    all('[data-product-variant]', root).forEach((node) => {
      if (node.dataset.productVariant === String(variant.id)) node.setAttribute('aria-current', 'true');
      else node.removeAttribute('aria-current');
    });
    const expectedAlt = variant.mediaAlt || `${root.rcProduct.title} ${variant.title}`;
    const media = all('[data-product-media]', root);
    const matching = media.filter((node) => root.rcProduct.defaultVariant || node.dataset.mediaAlt === expectedAlt || node.dataset.mediaAlt === root.rcProduct.title || !node.dataset.mediaAlt || node.dataset.mediaId === String(variant.mediaId));
    if (matching.length === 0 && media.length > 0) {
      matching.push(media.find((node) => node.dataset.mediaId === String(root.rcProduct.fallbackMediaId)) || media[0]);
    }
    media.forEach((node) => {
      node.hidden = !matching.includes(node);
      if (node.hidden) all('video', node).forEach((video) => video.pause());
    });
    const gallery = root.querySelector('[data-product-gallery]');
    gallery.scrollLeft = 0;
    updateGalleryCount(root);
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);
    }
  };
  const updateGalleryCount = (root) => {
    const gallery = root.querySelector('[data-product-gallery]');
    const visible = all('[data-product-media]:not([hidden])', gallery);
    const left = gallery.getBoundingClientRect().left;
    let closest = 0;
    let distance = Infinity;
    visible.forEach((node, index) => {
      const delta = Math.abs(node.getBoundingClientRect().left - left);
      if (delta < distance) { distance = delta; closest = index; }
    });
    setMessage(root.querySelector('[data-gallery-count]'), `${visible.length ? closest + 1 : 0} / ${visible.length}`);
    const prev = root.querySelector('[data-gallery-step="-1"]');
    const next = root.querySelector('[data-gallery-step="1"]');
    if (prev) prev.disabled = closest === 0;
    if (next) next.disabled = closest >= visible.length - 1;
    return { visible, closest };
  };
  const initialize = (scope = document) => {
    all('[data-product-root]', scope).forEach((root) => {
      if (root.rcProduct) return;
      try { root.rcProduct = JSON.parse(root.querySelector('[data-product-data]').textContent); } catch { return; }
      root.dataset.initialVariant = root.querySelector('[data-variant-select]').value;
      root.setAttribute('data-enhanced', '');
      syncSticky(root);
      syncFormButtons(root.querySelector('[data-add-form]'));
      const sticky = root.querySelector('[data-product-sticky]');
      const purchase = root.querySelector('.product-form__purchase');
      if (sticky && purchase && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        observer.observe(purchase);
        root.rcStickyObserver = observer;
      }
      let scheduled = false;
      root.querySelector('[data-product-gallery]')?.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { updateGalleryCount(root); scheduled = false; });
      }, { passive: true });
      updateGalleryCount(root);
    });
    all('[data-complement-variant]', scope).forEach(selectComplement);
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-cart-open]');
    if (opener && openCart(opener)) { event.preventDefault(); return; }
    if (event.target.closest('[data-cart-close]')) { closeCart(); return; }
    if (event.target.id === 'CartDrawer') {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) closeCart();
      return;
    }
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) { event.preventDefault(); quantityStep(stepper); return; }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.closest('[data-cart-line]'), 0); return; }
    const swatch = event.target.closest('[data-card-variant]');
    if (swatch && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      const card = swatch.closest('[data-product-card]');
      all('[data-card-variant]', card).forEach((node) => node.removeAttribute('aria-current'));
      swatch.setAttribute('aria-current', 'true');
      all('[data-card-link]', card).forEach((node) => { node.href = swatch.href; });
      const image = card.querySelector('.product-card__image');
      if (image && swatch.dataset.image) {
        image.removeAttribute('srcset');
        image.src = swatch.dataset.image;
        image.alt = swatch.dataset.imageAlt || '';
      }
      setMessage(card.querySelector('[data-card-price]'), swatch.dataset.price);
      const compare = card.querySelector('[data-card-compare]');
      if (compare) {
        const onSale = Number(swatch.dataset.compareCents) > Number(swatch.dataset.priceCents);
        compare.hidden = !onSale;
        setMessage(compare, onSale ? swatch.dataset.compare || '' : '');
      }
      syncDiscount(card.querySelector('[data-card-discount]'), swatch.dataset.priceCents, swatch.dataset.compareCents);
      setMessage(card.querySelector('[data-card-shade]'), swatch.dataset.label);
      return;
    }
    const variant = event.target.closest('[data-product-variant]');
    if (variant && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      const root = variant.closest('[data-product-root]');
      if (root.rcProduct) { event.preventDefault(); selectVariant(root, variant.dataset.productVariant); }
      return;
    }
    const galleryStep = event.target.closest('[data-gallery-step]');
    if (galleryStep) {
      const root = galleryStep.closest('[data-product-root]');
      const { visible, closest } = updateGalleryCount(root);
      const next = visible[closest + Number(galleryStep.dataset.galleryStep)];
      const gallery = root.querySelector('[data-product-gallery]');
      if (next) gallery.scrollBy({ left: next.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      return;
    }
    const zoomButton = event.target.closest('[data-zoom-src]');
    if (zoomButton) {
      const root = zoomButton.closest('[data-product-root]');
      const dialog = root.querySelector('[data-gallery-zoom]');
      const image = dialog.querySelector('[data-zoom-image]');
      image.src = zoomButton.dataset.zoomSrc;
      image.alt = zoomButton.dataset.zoomAlt;
      dialog.showModal();
      return;
    }
    if (event.target.closest('[data-zoom-close]')) event.target.closest('dialog')?.close();
  });
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.matches('[data-variant-select]')) selectVariant(target.closest('[data-product-root]'), target.value);
    if (target.matches('[data-complement-variant]')) selectComplement(target);
    if (target.matches('[name="quantity"]') && target.closest('[data-product-root]')) syncSticky(target.closest('[data-product-root]'));
    if (target.matches('[data-cart-quantity]')) {
      if (target.checkValidity()) changeLine(target.closest('[data-cart-line]'), Number(target.value));
      else target.reportValidity();
    }
    if (target.matches('[data-sort-select]')) target.form.requestSubmit();
  });
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.name === 'quantity') {
      const root = input.closest('[data-product-root]');
      if (root) syncSticky(root);
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-add-form]')) return;
    event.preventDefault();
    if (cartBusy || formVariant(form)?.available === false || !form.reportValidity()) return;
    cartBusy = true;
    const button = event.submitter || form.querySelector('[data-add-button]') || form.querySelector('[type="submit"]');
    const message = form.querySelector('[data-form-message]');
    form.setAttribute('aria-busy', 'true');
    all('[data-add-form]').forEach(syncFormButtons);
    setMessage(message, '');
    cartMessage('');
    try {
      const body = new FormData(form);
      body.set('sections', sectionIds().join(','));
      body.set('sections_url', window.location.pathname);
      const result = await post('cart/add.js', body);
      if (await syncCart(result.sections)) {
        setMessage(message, strings.added);
        if (!openCart(button)) window.location.assign(route('cart'));
      }
    } catch (error) {
      setMessage(message, error.message || strings.add_error);
    } finally {
      cartBusy = false;
      form.removeAttribute('aria-busy');
      all('[data-add-form]').forEach(syncFormButtons);
    }
  });
  window.addEventListener('popstate', () => {
    const id = new URL(window.location.href).searchParams.get('variant');
    all('[data-product-root]').forEach((root) => selectVariant(root, id || root.dataset.initialVariant, false));
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) refreshCart().catch(() => {}); });
  document.addEventListener('shopify:section:unload', (event) => all('[data-product-root]', event.target).forEach((root) => root.rcStickyObserver?.disconnect()));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  initialize();
})();

/* A styled select keeps Shopify's native field as the single form value. */
if ('showPopover' in HTMLElement.prototype && !customElements.get('rc-select')) {
  customElements.define('rc-select', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const select = this.querySelector('select');
      if (!select) return;
      this.ready = true;
      const options = [...select.options];
      const label = [...select.labels].map(node => node.textContent.trim()).join(' ');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rc-select__trigger';
      button.id = `${select.id}-trigger`;
      button.setAttribute('role', 'combobox');
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', `${select.id}-list`);
      if (select.dataset.cartFocus) { button.dataset.cartFocus = select.dataset.cartFocus; delete select.dataset.cartFocus; }
      const panel = document.createElement('div');
      panel.id = `${select.id}-list`;
      panel.className = 'rc-select__list';
      panel.popover = 'auto';
      panel.setAttribute('role', 'listbox');
      panel.setAttribute('aria-label', label);
      let active = select.selectedIndex;
      let search = '', searchTime = 0;
      const rows = options.map((option, index) => {
        const row = document.createElement('div');
        row.id = `${select.id}-option-${index}`;
        row.className = 'rc-select__option';
        row.setAttribute('role', 'option');
        row.setAttribute('aria-disabled', String(option.disabled));
        const title = document.createElement('span');
        title.textContent = option.dataset.label || option.textContent.trim();
        row.append(title);
        if (option.dataset.status) {
          const status = document.createElement('small');
          status.textContent = option.dataset.status;
          row.append(status);
        }
        row.addEventListener('pointerdown', event => event.preventDefault());
        row.addEventListener('click', () => commit(index));
        panel.append(row);
        return row;
      });
      const isOpen = () => panel.matches(':popover-open');
      const highlight = index => {
        active = index;
        rows.forEach((row, i) => row.toggleAttribute('data-active', i === active));
        button.setAttribute('aria-activedescendant', rows[active].id);
        const row = rows[active];
        if (row.offsetTop < panel.scrollTop) panel.scrollTop = row.offsetTop;
        else if (row.offsetTop + row.offsetHeight > panel.scrollTop + panel.clientHeight) panel.scrollTop = row.offsetTop + row.offsetHeight - panel.clientHeight;
      };
      const sync = () => {
        button.textContent = options[select.selectedIndex].dataset.label || options[select.selectedIndex].textContent.trim();
        button.setAttribute('aria-label', `${label}: ${button.textContent}`);
        button.disabled = select.disabled;
        rows.forEach((row, i) => row.setAttribute('aria-selected', String(i === select.selectedIndex)));
      };
      const close = () => { if (isOpen()) panel.hidePopover(); button.setAttribute('aria-expanded', 'false'); button.removeAttribute('aria-activedescendant'); };
      const open = () => {
        if (isOpen()) return;
        const rect = button.getBoundingClientRect();
        const below = innerHeight - rect.bottom - 14, above = rect.top - 14;
        const down = below >= Math.min(300, above);
        panel.style.width = `${Math.min(innerWidth - 24, Math.max(rect.width, 240))}px`;
        panel.style.maxHeight = `${Math.max(80, Math.min(340, down ? below : above))}px`;
        panel.showPopover();
        panel.style.left = `${Math.max(12, Math.min(rect.left, innerWidth - panel.offsetWidth - 12))}px`;
        panel.style.top = `${down ? rect.bottom + 6 : Math.max(12, rect.top - panel.offsetHeight - 6)}px`;
        button.setAttribute('aria-expanded', 'true');
        highlight(select.selectedIndex);
      };
      const commit = index => {
        if (options[index].disabled) return;
        select.selectedIndex = index;
        sync(); close(); button.focus({preventScroll:true});
        select.dispatchEvent(new Event('change', {bubbles:true}));
      };
      button.addEventListener('click', () => isOpen() ? close() : open());
      button.addEventListener('keydown', event => {
        if (event.key === 'Tab' || event.key === 'Escape') { close(); return; }
        if (['ArrowDown','ArrowUp','Home','End','Enter',' '].includes(event.key)) {
          event.preventDefault();
          if (!isOpen()) { open(); return; }
          if (event.key === 'Enter' || event.key === ' ') { commit(active); return; }
          const enabled = options.map((o,i) => o.disabled ? -1 : i).filter(i => i >= 0);
          const index = enabled.indexOf(active);
          highlight(event.key === 'Home' ? enabled[0] : event.key === 'End' ? enabled.at(-1) : enabled[Math.max(0, Math.min(enabled.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))]);
        } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          search = Date.now() - searchTime < 600 ? search + event.key : event.key;
          searchTime = Date.now();
          const match = options.findIndex(o => !o.disabled && (o.dataset.label || o.textContent).trim().toLocaleLowerCase().startsWith(search.toLocaleLowerCase()));
          if (match >= 0) { event.preventDefault(); open(); highlight(match); }
        }
      });
      panel.addEventListener('toggle', () => {
        if (!isOpen()) { button.setAttribute('aria-expanded','false'); button.removeAttribute('aria-activedescendant'); }
      });
      select.addEventListener('change', sync);
      select.form?.addEventListener('reset', () => requestAnimationFrame(sync));
      this.append(button, panel);
      sync();
      select.hidden = true;
      // The associated label targets the visible control after enhancement.
      [...select.labels].forEach(node => { node.htmlFor = button.id; });
      this.abort = new AbortController();
      window.addEventListener('resize', close, {signal:this.abort.signal});
      window.addEventListener('scroll', close, {passive:true, signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
